export default {
    PRESENTER_DISPLAY_STATE_KEY: 'display-state',
    PRESENTER_DISPLAY_STATES: {
        PRE_SHOW: 'PRE_SHOW',
        PHOTO_SELECT: 'PHOTO_SELECT',
        FORCE_IMAGE: 'FORCE_IMAGE', 
    },

    PRESENTER_ROTATION_STATE_KEY: 'rotation-state',
    PHOTO_ROTATION_STATES: {
        RESET: 'RESET',
        STARTED: 'STARTED',
        STOPPED: 'STOPPED',
    },

    PRESENTER_CHARACTER_PHOTOS_ONLY_KEY: 'character-photos-only',
    PRESENTER_PRACTICE_MODE_KEY: 'practice-mode',
    PRESENTER_VIEWED_PHOTOS_KEY: 'viewed-photos',

    PRESENTER_SELECTED_SHOW_KEY: 'selected-showId',
    PRESENTER_SHOW_DESC_KEY: 'selected-show-desc',
    PRESENTER_FORCED_URL_KEY: 'forced-photo-url',

    DDB_RECORD_TYPES: {
        PHOTO: 'Photo',
        SHOW: 'PProvShow',
    },

    PHOTO_APPROVAL_STATES: {
        PENDING: 'PENDING',
        APPROVED: 'APPROVED',
        REJECTED: 'REJECTED',
        USED_IN_PERFORMANCE: 'USED_IN_PERFORMANCE',
    },

    AGREE_CLICKED_KEY: 'agree-was-clicked',
    AUDIENCE_SHOWID_KEY: 'audience-show-id',

};
